// Feeds (Predictions) tab tour steps
import type { TourStep } from './types';

export const FEEDS_TOUR: TourStep[] = [
  {
    target: 'body',
    content: 'The Feeds tab shows AI-generated predictions based on your current dashas and transits.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="feeds-list"]',
    content: 'Predictions are organized by life area (career, relationships, health, etc.) with severity indicators.',
    placement: 'right',
  },
  {
    target: '[data-tour="feed-item"]',
    content: 'Each prediction shows the active time window, severity level, and which dasha levels are involved.',
    placement: 'left',
  },
  {
    target: '[data-tour="feed-evidence"]',
    content: 'Click "Show Evidence" to see the detailed scoring breakdown - how we arrived at this prediction.',
    placement: 'left',
  },
  {
    target: '[data-tour="life-areas-dashboard"]',
    content: 'The Life Areas Dashboard gives you a quick overview of all 15 life areas with current scores.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="future-alerts"]',
    content: 'Future Event Alerts show upcoming significant astrological events in the next 30-90 days.',
    placement: 'left',
  },
];
